import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { postData } from '@/services/api.service';
import { end_points } from '@/services/endpoints';
import { routes } from '@/utils/routes/routes';
import { useDispatch } from 'react-redux';
import {
  setActiveCustomerTab,
  setIsLoggedIn,
  setLoginToken,
  setUserDetails,
} from '@/core/redux/commonSlice';
import store from '@/core/redux/store';
import { toast } from 'react-toastify';

const schema = yup.object().shape({
  email: yup.string().email('Invalid email').required('Email is required'),
  password: yup.string().required('Password is required'),
});

const LoginComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [remember, setRemember] = useState(false);
  const token = store.getState().common.token;
  const [isloading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (token) {
      console.log(token);
    }
  }, [token]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data: { email: string; password: string }) => {
    console.log('Login Data:', data);

    const payload = {
      email: data.email,
      password: data.password,
    };
    try {
      setIsLoading(true);
      const response = await postData(end_points.login.url, payload);
      console.log(response?.data);

      if (response.status == 200 || response.status == 201) {
        toast.success('Loggged In');
        dispatch(setLoginToken(response?.data?.access_token));
        localStorage.setItem('token', response?.data?.access_token);
        dispatch(setIsLoggedIn(true));
        dispatch(setUserDetails(response?.data?.user));
        dispatch(setActiveCustomerTab('welcome'));
        navigate(location.state?.from || routes.customerDashboard);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
    // Perform login logic here (e.g., API call)
  };

  return (
    <section className="user-login-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            {/* {verify === 0 && (
              <div className="alert alert-warning mb-3">
                <p>
                  We have sent you an email. Just click on the link in that
                  email to verify.
                </p>
              </div>
            )}
            {verify === 1 && (
              <div className="alert alert-success mb-3">
                <p>Thank you for verifying your email.</p>
              </div>
            )} */}
            <div className="card-box">
              <div className="card-header">
                <h2>Sign In</h2>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    {...register('email')}
                    className="form-control"
                  />
                  <p className="text-danger">{errors.email?.message}</p>
                </div>
                <div className="form-group">
                  <label>Password</label>
                  <input
                    type="password"
                    {...register('password')}
                    className="form-control"
                  />
                  <p className="text-danger">{errors.password?.message}</p>
                </div>
                <div className="row">
                  {/* <div className="col-md-6 col-6 text-left">
                    <div className="res-box">
                      <div className="custom-control custom-checkbox text-center pl-0 mt-3 mb-3">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="remember"
                          checked={remember}
                          onChange={() => setRemember(!remember)}
                        />
                        <label
                          className="custom-control-label ms-1"
                          htmlFor="remember"
                        >
                          Remember Me
                        </label>
                      </div>
                    </div>
                  </div> */}
                  <div className="col-md-6 col-6 text-right">
                    <div className="res-box">
                      <div className="mt-3 mb-3">
                        <Link
                          to={routes.forgetPassword}
                          tabIndex={5}
                          className="forgot-password"
                        >
                          Forgot Password?
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group text-center">
                  <button
                    type="submit"
                    id="login-submit"
                    className="button style1"
                    disabled={isloading}
                  >
                    {isloading ? 'Loging in...' : 'Login'}
                  </button>
                </div>
                <div className="text-center">
                  Don't have an account?{' '}
                  <Link to={routes.register}>Sign up now</Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginComponent;
